<div class="block space-y-4">
  <section class="block rounded-lg border border-border bg-surface-elevated shadow-raised">
    <div class="p-6">
      <div class="flex items-start justify-between gap-4">
        <div class="min-w-0">
          <div class="text-[12px] font-extrabold uppercase tracking-[0.04em] text-text-muted">Current spend</div>
          <div class="mt-1 text-[32px] font-black leading-none tabular-nums text-text-title">
            {{ spent | currency: 'USD' : 'symbol' : '1.0-0' }}
          </div>
        </div>
        <button
          appUiButton
          appearance="ghost"
          tone="neutral"
          type="button"
          class="!h-auto !min-h-0 max-w-[10.5rem] shrink-0 items-center gap-1.5 !whitespace-normal !rounded-full !bg-surface-tint !px-2.5 !py-1.5 text-left"
          [attr.aria-label]="reportsEnabled() ? 'Open this month in Reports' : 'Open category chart'"
          (click)="openSpendingChart()"
        >
          <span class="inline-flex h-8 w-8 shrink-0 items-center justify-center text-brand-primary" aria-hidden="true">
            <app-ui-icon class="h-6 w-6" name="donut-chart" />
          </span>
          <span class="min-w-0 text-[10px] font-bold leading-snug text-brand-primary-strong">{{ spendingPaceLabel }}</span>
        </button>
      </div>

      <app-spend-trend-chart class="mt-2 block" [points]="spendingTrend()" />

      <div class="mt-1 flex items-center justify-between gap-6">
        <span class="inline-flex items-center gap-2 text-xs font-bold text-text-muted">
          <span class="h-1.5 w-12 rounded-full bg-brand-primary" aria-hidden="true"></span>
          This month
        </span>
        <span class="inline-flex items-center gap-2 text-xs font-bold text-text-muted">
          <span class="h-1.5 w-12 rounded-full bg-border-default" aria-hidden="true"></span>
          Planned pace
        </span>
      </div>
    </div>
  </section>

  @let unsortedTransactionsCount = (unsortedTransactionsCount$ | async) ?? 0;
  @let todoCount = attentionCount() + (unsortedTransactionsCount > 0 ? 1 : 0);
  @if (todoCount > 0) {
    <section class="block overflow-hidden rounded-lg border border-border bg-surface-elevated shadow-raised">
      <div class="flex items-center justify-between border-b border-border-muted px-6 py-4">
        <span class="text-[11px] font-extrabold uppercase tracking-[0.08em] text-text-muted">Needs your attention</span>
        <span class="rounded-full bg-surface-muted px-2.5 py-1 text-[11px] font-extrabold text-text-title">
          {{ todoCount }} to do
        </span>
      </div>

      @if (topOverBudgetBucket; as overBudgetBucket) {
        <app-ui-action-row
          icon="info"
          tone="danger"
          emphasizeTitle
          divider
          [title]="overBudgetBuckets.length + ' budget' + (overBudgetBuckets.length === 1 ? '' : 's') + ' over budget'"
          [subtitle]="overBudgetBucket.name + ' · ' + (bucketRemaining(overBudgetBucket) | currency: 'USD' : 'symbol' : '1.0-2')"
          (action)="openOverBudget()"
        />
      }

      @if (hasUnbudgetedBalance()) {
        <app-ui-action-row
          class="categories-page-summary-unbudgeted-action"
          icon="money-check"
          [tone]="unbudgetedBalance() > 0 ? 'primary' : 'danger'"
          [emphasizeTitle]="unbudgetedBalance() < 0"
          divider
          [title]="unbudgetedBalanceTitle()"
          [subtitle]="unbudgetedBalanceSubtitle()"
          (action)="openUnbudgetedBalance()"
        />
      }

      @if (hasLeftToBudget) {
        <app-ui-action-row
          class="categories-page-summary-assign-action"
          icon="money-check"
          tone="primary"
          divider
          [title]="'Assign ' + (leftToBudget | currency: 'USD' : 'symbol' : leftToBudgetDigits)"
          subtitle="Left to budget this month"
          (action)="openAssignMoney()"
        />
      }

      @if (isOverassigned) {
        <app-ui-action-row
          class="categories-page-summary-overassigned-action"
          icon="money-check"
          tone="danger"
          emphasizeTitle
          divider
          [title]="'Overbudget by ' + (overassignedAmount | currency: 'USD' : 'symbol' : overassignedAmountDigits)"
          subtitle="Assigned over this month's income"
          (action)="openAssignMoney()"
        />
      }

      @if (suggestedRuleCount(); as suggestedRuleCount) {
        <app-ui-action-row
          class="categories-page-summary-suggested-rules-action"
          icon="list"
          tone="primary"
          [divider]="unsortedTransactionsCount > 0"
          [title]="'Review ' + suggestedRuleCount + ' suggested transaction rule' + (suggestedRuleCount === 1 ? '' : 's')"
          subtitle="Sort repeat merchants automatically"
          (action)="openSuggestedRules()"
        />
      }

      @if (unsortedTransactionsCount > 0) {
        <app-ui-action-row
          icon="receipt-text"
          tone="warn"
          [title]="'Review ' + unsortedTransactionsCount + ' transaction' + (unsortedTransactionsCount === 1 ? '' : 's')"
          subtitle="Waiting to be categorized"
          (action)="openUncategorizedTransactions()"
        />
      }
    </section>
  }

  <app-upcoming-recurring-cards class="block" />

</div>
